var _style, _path, _g, _path2, _path3, _path4, _g2, _path5, _g3, _path6, _rect, _path7, _path8, _path9, _path10, _g4, _path11, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _g5, _path12, _path13, _polygon, _path14, _rect13, _path15, _g6, _g7, _path16, _g8, _g9, _g10, _g11, _g12, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _polygon2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolutionDevops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 458.99 294.62",
    style: {
      enableBackground: "new 0 0 458.99 294.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st1{fill:#676D7C;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#FF9877;}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{opacity:0.54;fill:url(#SVGID_6_);enable-background:new    ;}\n\t.st9{opacity:0.54;fill:url(#SVGID_7_);enable-background:new    ;}\n\t.st10{opacity:0.54;fill:url(#SVGID_8_);enable-background:new    ;}\n\t.st11{fill:#84ACB9;}\n\t.st12{opacity:0.54;fill:url(#SVGID_9_);enable-background:new    ;}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:#AFD4C2;}\n\t.st15{opacity:0.2;enable-background:new    ;}\n\t.st16{fill:url(#SVGID_11_);}\n\t.st17{fill:url(#SVGID_12_);}\n\t.st18{fill:url(#SVGID_13_);}\n\t.st19{fill:#33A1F5;}\n\t.st20{opacity:0.54;fill:url(#SVGID_14_);enable-background:new    ;}\n\t.st21{opacity:0.68;fill:#FF9877;enable-background:new    ;}\n\t.st22{fill:#FDCEDC;}\n\t.st23{opacity:0.3;enable-background:new    ;}\n\t.st24{fill:url(#SVGID_15_);}\n\t.st25{fill:url(#SVGID_16_);}\n\t.st26{fill:url(#SVGID_17_);}\n\t.st27{fill:url(#SVGID_18_);}\n\t.st28{fill:#25272B;}\n\t.st29{fill:url(#SVGID_19_);}\n\t.st30{fill:url(#SVGID_20_);}\n\t.st31{fill:url(#SVGID_21_);}\n\t.st32{fill:url(#SVGID_22_);}\n\t.st33{fill:url(#SVGID_23_);}\n\t.st34{fill:url(#SVGID_24_);}\n\t.st35{fill:url(#SVGID_25_);}\n\t.st36{fill:url(#SVGID_26_);}\n\t.st37{fill:url(#SVGID_27_);}\n\t.st38{fill:url(#SVGID_28_);}\n\t.st39{fill:url(#SVGID_29_);}\n\t.st40{fill:url(#SVGID_30_);}\n\t.st41{fill:url(#SVGID_31_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.4435,
    y1: 1404.6599,
    x2: 427.9767,
    y2: 927.4224,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.99,291.62V51.33c-52.78,7.55-151.73-5.31-151.73,40.93c0,74.38-80.08,32.64-117.53,121.5 c-31.43,74.59-85.49,44.76-90.91,80.86h357.17C457.65,294.62,458.99,293.28,458.99,291.62z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.36,166.47c0,0.1-0.04,0.17-0.09,0.25l-0.28,0.43h-0.26l0.2-0.43c-0.09-0.05-0.13-0.14-0.13-0.25 c0-0.17,0.12-0.3,0.28-0.3C130.23,166.17,130.36,166.28,130.36,166.47z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -1226.9563,
    y1: 2023.177,
    x2: -1193.1854,
    y2: 2023.177,
    gradientTransform: "matrix(-0.8192 -0.5736 -0.5736 0.8192 573.8209 -2270.6191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#04F1AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#18F2CF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385.2,93.59c3.16,3.59,7.35,3.48,9.22,2.85l0.34,0.15c1.4,2.2,6.46,5.56,10.15,5.28 c3.72-0.29,8.87-1.6,9.68-7.57c-3.75-1.56-5.08,3.01-9.75-0.21c-1.77-1.22-0.36-4.26,2.19-4.01c3.2,0.31,7.41,2.19,10.21-0.3 c2.81-2.49,2.67-8.71,1.27-10.4c-2.77,4.78-5.81,4.87-6.97,3.77c-1.21-1.15-1.44-2.7,0.85-5.32c1.43-1.63,4.33-1.88,5.15-3.77 c1.26-2.92-2.01-8.97-0.45-11.13c0,0-2.4,0.76-6.77,1.99s-3.88,3.7-4.61,6.84c-0.83,3.62-4.95,2.31-3.61-1.11 c1.22-3.09,0.94-6.42,0.94-5.89c-3.43,2.09-6.65,2.59-5.62,5.4c2.02,5.49,3.12,8.43-0.16,9.12s-2.77-6.03-2.09-8.29 c-4.5,1.49-6.5,4.08-5.56,7.39s6.55,8.3,3.28,9.24c-3.28,0.94-6.89-8.58-6.72-9.83C381.51,83.99,382.04,90,385.2,93.59z  M406.18,86.91c0.12-0.5,0.66-0.75,1.15-0.91c0.99-0.34,2.99-0.69,3.32,0.82c0.1,0.48-0.19,0.96-0.57,1.28 c-0.94,0.78-2.44,0.78-3.37-0.01C406.35,87.79,406.07,87.35,406.18,86.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -1215.6373,
    y1: 2029.9402,
    x2: -1204.7478,
    y2: 2029.9402,
    gradientTransform: "matrix(-0.8192 -0.5736 -0.5736 0.8192 574.9733 -2266.7397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F97AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CFE7FC"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M392.47,113.26c0.1,0,0.2-0.06,0.23-0.17c1.07-3.26,1.07-6.82,1.07-10.25c0-4.43,0-8.61,2.08-12.27 c1.58-2.77,4.18-4.81,6.71-6.77c2.29-1.79,4.66-3.64,6.32-6.06c0.94-1.37,1.62-2.91,2.29-4.4c0.65-1.46,1.33-2.97,2.24-4.3 c0.08-0.11,0.05-0.26-0.06-0.33c-0.11-0.08-0.26-0.05-0.33,0.06c-0.93,1.37-1.61,2.9-2.28,4.38c-0.66,1.47-1.34,2.99-2.25,4.32 c-1.61,2.36-3.95,4.19-6.21,5.95c-2.56,1.99-5.21,4.06-6.83,6.91c-2.14,3.77-2.14,8.21-2.14,12.51c0,3.4,0,6.91-1.04,10.1 c-0.04,0.13,0.03,0.26,0.15,0.3C392.42,113.25,392.44,113.26,392.47,113.26z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -317.7024,
    y1: 1912.1956,
    x2: -259.3888,
    y2: 1912.1956,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -589.8448 -1586.6064)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#26F3F5"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M295.85,133.28c0.15,0.12,0.33,0.24,0.47,0.37c13.69,10.83,14.3,27.16-2.89,35.59 c-0.01,0.04-0.01,0.09-0.04,0.12c-0.14,0.62-0.35,1.22-0.58,1.8c-4.48,11.35-22.63,18.93-34.06,7 c-2.25-2.35-4.36-5.02-6.31-7.93c-0.27-0.42-0.54-0.84-0.8-1.27c-2.6-4.1-4.88-8.66-6.79-13.53c-0.18-0.45-0.36-0.89-0.52-1.35 c-1.55-4.12-2.83-8.43-3.81-12.82c-0.1-0.49-0.2-0.97-0.31-1.44c-1.11-5.36-1.76-10.82-1.92-16.22c0-0.22-0.02-0.43-0.03-0.65 c0.45-0.08,0.91-0.15,1.36-0.2c5.8-0.85,11.96-1.01,18.01-0.62c0.49,0.02,0.99,0.06,1.47,0.1c6.02,0.46,11.89,1.45,17.24,2.8 c0.47,0.11,0.94,0.24,1.4,0.36c7.2,1.92,13.36,4.52,17.37,7.39C295.38,132.93,295.61,133.1,295.85,133.28z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.51,158.83l12.81-25.18c-0.15-0.13-0.32-0.26-0.47-0.37c-0.23-0.17-0.47-0.35-0.73-0.52l-12.7,25 c-3.77-3.7-7.68-7.26-11.56-10.68l6.88-21.71c-0.46-0.12-0.93-0.25-1.4-0.36l-6.67,21.04c-4.69-4.05-9.35-7.83-13.76-11.23l0,0 l3.19-12.6c-0.48-0.04-0.98-0.08-1.47-0.1l-2.96,11.74v0.01l-0.01-0.01c-5.7-4.44-10.91-8.2-15.04-11.11 c-0.46,0.04-0.92,0.11-1.37,0.2c0.02,0.23,0.03,0.44,0.04,0.65c3.79,2.68,9.22,6.59,15.41,11.41l0,0l0,0l-13.49,4.81 c0.11,0.47,0.21,0.95,0.31,1.44l14.4-5.15l-0.08-0.19c4.21,3.28,8.74,6.97,13.34,10.95l0,0l-23.85,7.22 c0.17,0.46,0.34,0.91,0.52,1.35l24.61-7.46h0.01c4.01,3.5,8.03,7.2,11.94,11.06c0,0,0.01,0,0.01,0.01h-0.01l-29.78,9.93 c0.26,0.43,0.53,0.85,0.8,1.27l29.98-10.01l-0.08-0.27l0.02-0.01c3.64,3.64,7.16,7.4,10.46,11.23l0.58-1.8 C290.28,165.75,286.95,162.26,283.51,158.83C283.52,158.83,283.52,158.83,283.51,158.83z"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M401.12,85.43v154.8c0,4.05-3.29,7.34-7.34,7.34H282.34c-4.06,0-7.34-3.29-7.34-7.34V85.43 c0-4.05,3.28-7.34,7.34-7.34h111.44C397.83,78.09,401.12,81.38,401.12,85.43z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.47,228.54V91.72c0-2.76,2.24-5,5-5h107.18c2.76,0,5,2.24,5,5v136.81c0,2.76-2.24,5-5,5H284.47 C281.71,233.54,279.47,231.3,279.47,228.54z"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M334.21,240.83c0-2.12,1.72-3.85,3.85-3.85c2.12,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85 C335.93,244.68,334.21,242.95,334.21,240.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -233.0151,
    y1: 1849.1029,
    x2: -218.6313,
    y2: 1849.1029,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -537.5911 -1561.6572)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 329.63,
    y: 82.16,
    className: "st7",
    width: 16.86,
    height: 1
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.17,
    y1: 1019.985,
    x2: 352.96,
    y2: 1019.985,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M352.96,96.64v58.69c0,1.66-1.34,3-3,3h-60.79c-1.66,0-3-1.34-3-3V96.64c0-1.66,1.34-3,3-3h60.79 C351.62,93.64,352.96,94.98,352.96,96.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.09,
    y1: 1019.985,
    x2: 390.21,
    y2: 1019.985,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M390.21,96.64v58.69c0,1.66-1.34,3-3,3h-25.12c-1.66,0-3-1.34-3-3V96.64c0-1.66,1.34-3,3-3h25.12 C388.87,93.64,390.21,94.98,390.21,96.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.42,
    y1: 1089.175,
    x2: 390.21,
    y2: 1089.175,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M323.42,224.52v-58.69c0-1.66,1.34-3,3-3h60.79c1.66,0,3,1.34,3,3v58.69c0,1.66-1.34,3-3,3h-60.79 C324.77,227.52,323.42,226.17,323.42,224.52z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M260.91,103.73h-26.76c-1.56,0-2.83-1.27-2.83-2.83v-9.98c0-1.56,1.27-2.83,2.83-2.83h26.76 c1.56,0,2.83,1.27,2.83,2.83v9.98C263.74,102.45,262.46,103.73,260.91,103.73z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M240.24,93.42v4.69h-1.09v-1.92h-2.13v1.92h-1.09v-4.69h1.09v1.85h2.13v-1.85H240.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M243.66,94.31h-1.5v-0.88h4.09v0.88h-1.5v3.81h-1.09V94.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.45,98.11l-0.01-2.82l-1.38,2.32h-0.49l-1.38-2.26v2.76h-1.02v-4.69h0.9l1.76,2.92l1.73-2.92h0.89 l0.01,4.69H252.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M255.92,93.42h1.09v3.81h2.35v0.88h-3.44L255.92,93.42L255.92,93.42z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.17,
    y1: 1089.175,
    x2: 317.29,
    y2: 1089.175,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M286.17,224.52v-58.69c0-1.66,1.34-3,3-3h25.12c1.66,0,3,1.34,3,3v58.69c0,1.66-1.34,3-3,3h-25.12 C287.52,227.52,286.17,226.17,286.17,224.52z"
  })), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 173.32,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 177.55,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 181.78,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 186.02,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 190.25,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 194.48,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 198.71,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 202.94,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 207.18,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 211.41,
    className: "st5",
    width: 2.04,
    height: 2.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -231.2466,
    y1: 1983.0966,
    x2: -228.4055,
    y2: 1983.0966,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -615.1746 -1539.7181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 333.04,
    y: 215.64,
    className: "st13",
    width: 2.04,
    height: 2.04
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 341.63,
    y: 173.32,
    className: "st6",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.21,
    y: 173.32,
    className: "st6",
    width: 18.74,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.03,
    y: 177.55,
    className: "st14",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.6,
    y: 177.55,
    className: "st5",
    width: 5.46,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.49,
    y: 177.55,
    className: "st11",
    width: 14.11,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.06,
    y: 181.78,
    className: "st5",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.63,
    y: 186.02,
    className: "st6",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.03,
    y: 190.25,
    className: "st11",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.6,
    y: 190.25,
    className: "st5",
    width: 5.46,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.06,
    y: 194.48,
    className: "st11",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.63,
    y: 194.48,
    className: "st11",
    width: 9.31,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.63,
    y: 198.71,
    className: "st14",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.03,
    y: 202.94,
    className: "st6",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.49,
    y: 202.94,
    className: "st5",
    width: 14.11,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.06,
    y: 207.18,
    className: "st11",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.63,
    y: 211.41,
    className: "st6",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.21,
    y: 211.41,
    className: "st6",
    width: 18.74,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.6,
    y: 215.64,
    className: "st5",
    width: 5.46,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.49,
    y: 215.64,
    className: "st11",
    width: 14.11,
    height: 2.04
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M303.75,164.17v34.15c0,2.74-2.22,4.97-4.97,4.97H275v-44.08h23.78 C301.53,159.21,303.75,161.43,303.75,164.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -311.9497,
    y1: 2004.162,
    x2: -221.0155,
    y2: 2004.162,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -633.5563 -1556.7695)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9877",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7988A",
      stopOpacity: 0.68
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M337.74,260.33v-43.87c0-1.22-0.99-2.21-2.21-2.21h-75.39c-1.22,0-2.21,0.99-2.21,2.21v43.87H337.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -312.1646,
    y1: 2036.0677,
    x2: -228.2362,
    y2: 2036.0677,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -650.4459 -1551.4438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9877",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7988A",
      stopOpacity: 0.68
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "347.86,275.67 247.79,275.67 257.91,257.8 337.74,257.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -306.618,
    y1: 2042.3076,
    x2: -224.6493,
    y2: 2042.3076,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -655.9929 -1549.6948)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E098A9",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B398BA",
      stopOpacity: 0.68
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M344.91,277.14h-94.16c-0.92,0-1.81-0.36-2.47-1l-0.49-0.47h100.07l-0.49,0.47 C346.71,276.78,345.83,277.14,344.91,277.14z"
  })))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 261.21,
    y: 217.55,
    className: "st5",
    width: 73.22,
    height: 36.95
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306.07,273.22h-16.49c-0.35,0-0.59-0.35-0.46-0.68l2.14-5.54c0.18-0.46,0.62-0.76,1.11-0.76h10.9 c0.49,0,0.93,0.3,1.11,0.76l2.14,5.54C306.66,272.87,306.42,273.22,306.07,273.22z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 103.88,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 108.12,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 112.35,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 116.58,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 120.82,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 125.05,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 129.28,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 133.51,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 137.75,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 141.98,
    className: "st5",
    width: 2.04,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.79,
    y: 146.21,
    className: "st5",
    width: 2.04,
    height: 2.04
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 304.38,
    y: 103.88,
    className: "st6",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.96,
    y: 103.88,
    className: "st6",
    width: 18.74,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.78,
    y: 108.12,
    className: "st14",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.35,
    y: 108.12,
    className: "st5",
    width: 5.46,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.24,
    y: 108.12,
    className: "st14",
    width: 14.11,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.81,
    y: 112.35,
    className: "st5",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.38,
    y: 116.58,
    className: "st11",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.78,
    y: 120.82,
    className: "st14",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.35,
    y: 120.82,
    className: "st5",
    width: 5.46,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.24,
    y: 120.82,
    className: "st5",
    width: 14.11,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.81,
    y: 125.05,
    className: "st14",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.38,
    y: 125.05,
    className: "st6",
    width: 9.31,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.38,
    y: 129.28,
    className: "st11",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.96,
    y: 129.28,
    className: "st5",
    width: 18.74,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.78,
    y: 133.51,
    className: "st11",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.24,
    y: 133.51,
    className: "st5",
    width: 14.11,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.81,
    y: 137.75,
    className: "st11",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.38,
    y: 141.98,
    className: "st14",
    width: 10.14,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.96,
    y: 141.98,
    className: "st11",
    width: 18.74,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.35,
    y: 146.21,
    className: "st5",
    width: 5.46,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.24,
    y: 146.21,
    className: "st6",
    width: 14.11,
    height: 2.04
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M292.78,198.29h-34.15c-2.74,0-4.97-2.22-4.97-4.97v-34.15c0-2.74,2.22-4.97,4.97-4.97h34.15 c2.74,0,4.97,2.22,4.97,4.97v34.15C297.75,196.06,295.53,198.29,292.78,198.29z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M271.08,174.06l-6.04,2.21l6.04,2.2v2.27l-8.64-3.28v-2.36l8.64-3.29V174.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M277.58,167.35h2.52l-5.99,17.09h-2.52L277.58,167.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M289.06,175.1v2.36l-8.64,3.28v-2.27l6.04-2.2l-6.04-2.21v-2.25L289.06,175.1z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M382.41,152.02h-15.53c-1.92,0-3.5-1.58-3.5-3.5l0,0c0-1.92,1.58-3.5,3.5-3.5h15.53 c1.93,0,3.5,1.58,3.5,3.5l0,0C385.91,150.44,384.34,152.02,382.41,152.02z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M371.06,149.4c-0.17-0.09-0.31-0.22-0.41-0.39s-0.15-0.35-0.15-0.56c0-0.21,0.05-0.39,0.15-0.56 c0.1-0.16,0.23-0.29,0.41-0.39c0.17-0.09,0.37-0.14,0.58-0.14c0.18,0,0.35,0.03,0.49,0.1c0.15,0.06,0.27,0.16,0.37,0.28 l-0.31,0.29c-0.14-0.16-0.32-0.25-0.53-0.25c-0.13,0-0.25,0.03-0.35,0.09s-0.18,0.14-0.24,0.24s-0.09,0.22-0.09,0.35 s0.03,0.25,0.09,0.35s0.14,0.18,0.24,0.24c0.1,0.06,0.22,0.08,0.35,0.08c0.21,0,0.39-0.08,0.53-0.25l0.31,0.29 c-0.1,0.12-0.22,0.21-0.37,0.28c-0.15,0.06-0.31,0.1-0.5,0.1C371.43,149.54,371.24,149.5,371.06,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M373.63,149.48c-0.15-0.04-0.28-0.1-0.37-0.18l0.17-0.37c0.09,0.07,0.2,0.12,0.32,0.16 c0.12,0.04,0.25,0.06,0.37,0.06c0.14,0,0.24-0.02,0.3-0.06c0.07-0.04,0.1-0.09,0.1-0.16c0-0.05-0.02-0.09-0.06-0.12 s-0.09-0.06-0.15-0.08s-0.14-0.04-0.25-0.07c-0.16-0.04-0.29-0.08-0.39-0.11c-0.1-0.04-0.19-0.1-0.26-0.18 c-0.07-0.08-0.11-0.2-0.11-0.34c0-0.12,0.03-0.23,0.1-0.33s0.17-0.18,0.3-0.24c0.13-0.06,0.3-0.09,0.49-0.09 c0.13,0,0.27,0.02,0.39,0.05c0.13,0.03,0.24,0.08,0.34,0.14l-0.15,0.37c-0.19-0.11-0.39-0.16-0.58-0.16 c-0.13,0-0.24,0.02-0.3,0.07c-0.06,0.04-0.1,0.1-0.1,0.17c0,0.07,0.04,0.12,0.11,0.16c0.07,0.04,0.19,0.07,0.34,0.1 c0.16,0.04,0.29,0.08,0.39,0.11c0.1,0.04,0.19,0.1,0.26,0.18c0.07,0.08,0.11,0.19,0.11,0.33c0,0.12-0.03,0.23-0.1,0.33 s-0.17,0.18-0.3,0.24c-0.13,0.06-0.3,0.09-0.49,0.09C373.94,149.54,373.78,149.52,373.63,149.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376.14,149.48c-0.15-0.04-0.28-0.1-0.37-0.18l0.16-0.37c0.09,0.07,0.2,0.12,0.32,0.16 c0.12,0.04,0.25,0.06,0.37,0.06c0.14,0,0.24-0.02,0.31-0.06s0.1-0.09,0.1-0.16c0-0.05-0.02-0.09-0.06-0.12s-0.09-0.06-0.15-0.08 s-0.14-0.04-0.25-0.07c-0.16-0.04-0.29-0.08-0.39-0.11c-0.1-0.04-0.19-0.1-0.26-0.18c-0.07-0.08-0.11-0.2-0.11-0.34 c0-0.12,0.03-0.23,0.1-0.33s0.17-0.18,0.3-0.24c0.13-0.06,0.29-0.09,0.49-0.09c0.13,0,0.27,0.02,0.39,0.05 c0.13,0.03,0.24,0.08,0.34,0.14l-0.15,0.37c-0.2-0.11-0.39-0.16-0.58-0.16c-0.14,0-0.24,0.02-0.3,0.07 c-0.06,0.04-0.1,0.1-0.1,0.17c0,0.07,0.04,0.12,0.11,0.16c0.08,0.04,0.19,0.07,0.34,0.1c0.16,0.04,0.29,0.08,0.39,0.11 c0.1,0.04,0.19,0.1,0.26,0.18c0.07,0.08,0.11,0.19,0.11,0.33c0,0.12-0.03,0.23-0.1,0.33s-0.17,0.18-0.3,0.24 c-0.13,0.06-0.3,0.09-0.49,0.09C376.46,149.54,376.3,149.52,376.14,149.48z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.58,110.44h-3.62c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.62c0.2,0,0.36,0.16,0.36,0.36 C381.93,110.28,381.77,110.44,381.58,110.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376.36,110.44h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C376.72,110.28,376.56,110.44,376.36,110.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.58,104.08h-3.62c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.62c0.2,0,0.36,0.16,0.36,0.36 C381.93,103.92,381.77,104.08,381.58,104.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376.36,104.08h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C376.72,103.92,376.56,104.08,376.36,104.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M371.34,107.47h-3.62c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.62c0.2,0,0.36,0.16,0.36,0.36 C371.7,107.31,371.54,107.47,371.34,107.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.58,107.47h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C381.93,107.31,381.77,107.47,381.58,107.47z"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.58,123.44h-3.62c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.62c0.2,0,0.36,0.16,0.36,0.36 C381.93,123.28,381.77,123.44,381.58,123.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376.36,123.44h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C376.72,123.28,376.56,123.44,376.36,123.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.58,117.08h-3.62c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.62c0.2,0,0.36,0.16,0.36,0.36 C381.93,116.92,381.77,117.08,381.58,117.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376.36,117.08h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C376.72,116.92,376.56,117.08,376.36,117.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M371.34,120.47h-3.62c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.62c0.2,0,0.36,0.16,0.36,0.36 C371.7,120.31,371.54,120.47,371.34,120.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.58,120.47h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C381.93,120.31,381.77,120.47,381.58,120.47z"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.58,136.44h-3.62c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.62c0.2,0,0.36,0.16,0.36,0.36 C381.93,136.28,381.77,136.44,381.58,136.44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376.36,136.44h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C376.72,136.28,376.56,136.44,376.36,136.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.58,130.08h-3.62c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.62c0.2,0,0.36,0.16,0.36,0.36 C381.93,129.92,381.77,130.08,381.58,130.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376.36,130.08h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C376.72,129.92,376.56,130.08,376.36,130.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M371.34,133.47h-3.62c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.62c0.2,0,0.36,0.16,0.36,0.36 C371.7,133.31,371.54,133.47,371.34,133.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M381.58,133.47h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C381.93,133.31,381.77,133.47,381.58,133.47z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.31,
    y1: 1131.0001,
    x2: 309.6,
    y2: 1131.0001,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M309.6,228.42l-7.64,6.75l-0.75,0.66c-1.01-0.63-2.18-0.95-3.38-0.95c-3.6,0-6.52,2.92-6.52,6.52 c0,1.14,0.29,2.26,0.86,3.23l-9.54,5.49c-1.52-2.65-2.32-5.66-2.32-8.72c0-9.66,7.86-17.52,17.52-17.52 c3.47,0,6.83,1.01,9.71,2.93C308.27,227.3,308.96,227.84,309.6,228.42z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M315.35,241.4c0,3.06-0.81,6.07-2.33,8.72l-9.53-5.48c0.56-0.98,0.86-2.1,0.86-3.24 c0-1.61-0.59-3.13-1.62-4.3l7.25-8.33C313.39,232.04,315.35,236.58,315.35,241.4z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M310.21,228.51l-0.23,0.26l-7.25,8.33l-3.92,4.5c-0.27,0.31-0.65,0.47-1.03,0.47c-0.35,0-0.71-0.13-0.98-0.4 c-0.56-0.56-0.53-1.48,0.06-2l4.35-3.84l0.75-0.66l7.64-6.75l0.27-0.24C310.09,227.99,310.4,228.29,310.21,228.51z"
  }))), /*#__PURE__*/React.createElement("g", null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M251.96,179.08c1.67-0.29,2.15-1.21,3.19-2.17c1.04-0.96,4.55-1.29,6.01-0.39s2.47,2.01,2.47,2.01 c-1.8,0.59-3.83-0.77-5.25-0.12c-1.42,0.66-3,1.31-3.55,1.51c1.11,0.26,2.87-0.77,3.84-0.84c0.97-0.07,1.89-0.33,2.06,0.46 c-0.78,0.14-2.08,0.43-2.63,0.66c-0.55,0.23-2.33,1.9-3.3,1.26s-1.86-0.82-2.77-0.62C251.12,181.03,251.96,179.08,251.96,179.08z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M222.65,158.77l-1.09-0.44c0,0,2.62,1.62,4.12,1.24c3.71-0.96,2.7-13.19,2.7-13.19 c-0.4-1.56-1.18-1.08-1.83-1.06c-0.66,0.03-7.55-0.34-9.59,2.67s-1.67,5.52-1.1,7.47c0.58,1.94,0.32,5.99,0.32,5.99l3.68,2.58 l1.43-0.04L222.65,158.77z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M226.53,145.32c0.53-0.02,1.15-0.33,1.58,0.41c-0.3,0.27-0.85,0.46-1.26,0.67 c-1.16,0.59-2.44,0.02-3.34,0.95c-0.27,0.28-1.69,1.5-1.72,1.88c-0.08,1,2.12,2.58,0.35,5.43c-0.39,0.63-1.58,2.53-1.42,3.06 c0.34,1.14,2.18,0.42,3.1,1.49c0.04,0.04-0.08,0.08-0.12,0.13c-0.38-0.13-2.27-0.6-2.6-0.76l1.33,1.05l-0.27,0.98 c-0.38,0.65-6.08,0.69-5.97-0.05c0.49-3.28-1.25-9.61,0.76-12.58C218.98,144.97,225.86,145.34,226.53,145.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.864,
    y1: 1041.5267,
    x2: 229.3133,
    y2: 1041.5267,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0006364288,
    style: {
      stopColor: "#E18C44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76446"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M228.35,146.88c1.64-3.13,1.1-5.87-0.71-6.49c-3.77-1.4-6.78-0.83-8.51,0.74c-1.01,0.14-2.91,0.19-3.48,2.2 c-2.48,0.81-3.17,2.72-2.56,5.84c0.2,2.29,1.73,4.31,2.78,6.29c1.53-1.72-0.34-3.5,0.55-4.48c0.78-0.86,2.03,0.09,2.46,1.16 c0.28,0.13,1.6,0,1.6,0l-0.61-4.53C222.17,145.7,226.48,145.73,228.35,146.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.8111,
    y1: 1160.6669,
    x2: 206.8026,
    y2: 1160.6669,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E098A9",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B398BA",
      stopOpacity: 0.68
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M221.5,267.2c0.29,0.59,0.37,1.07,0.27,1.32c-0.1,0.25-0.37,1.05-2.59,1.36c-2.94,0.41-4.51-0.27-7.6-1.01 c-2.91-0.7-4.24-1.13-4.67-2.19s0.57-3.35,0.57-3.35l6.03,2.21L221.5,267.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M211.55,260.62c1.23,1.43,2.82,2.32,4.42,3.4c0.97,0.66,3.46,1.62,4.47,2.19c1.01,0.58,1.38,1.34,1.02,1.65 s-2.41,0.88-4.13,0.69c-3.01-0.31-4.62-1.04-7.22-1.75c-2.47-0.67-3.07-1.53-2.98-2.47c0.09-0.95,0.13-3.66,0.13-3.66 L211.55,260.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.9723,
    y1: 1156.8838,
    x2: 233.9625,
    y2: 1156.8838,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E098A9",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B398BA",
      stopOpacity: 0.68
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M248.48,261.85c0.38,0.52,0.54,0.97,0.48,1.23c-0.05,0.26-0.18,1.08-2.28,1.76 c-2.78,0.9-4.34,0.37-7.91-0.49c-2.87-0.69-3.94,0.42-4.54-0.54c-0.59-0.96-0.02-3.35-0.02-3.35l6.23,1.12L248.48,261.85z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M237.71,257.15c1.44,1.18,3.13,1.77,4.87,2.55c1.06,0.48,3.63,0.98,4.71,1.37c1.07,0.39,1.57,1.07,1.27,1.43 s-2.19,1.26-3.89,1.38c-2.97,0.21-3.76-0.68-6.41-0.93c-2.52-0.23-4.14-0.5-4.21-1.44c-0.07-0.93-0.5-3.57-0.5-3.57L237.71,257.15 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -423.1039,
    y1: 2252.1111,
    x2: -391.4009,
    y2: 2252.1111,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -728.418 -1853.0234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33A1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0DE5F0"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M214.8,199.86c3.52,7.04,14.84,21.07,17.82,26.23c0.59,8.07-3.1,26.63,0.93,32.45 c1.21,0.67,3.54-0.21,4.41-1.71c-0.91-4.29,2.86-29.48,2.16-31.94c-1.18-4.66-10.99-23.54-14.45-32.88 C222.18,191.91,214.8,199.86,214.8,199.86z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M214.8,199.86c3.52,7.04,14.84,21.07,17.82,26.23c0.59,8.07-3.1,26.63,0.93,32.45 c1.21,0.67,3.54-0.21,4.41-1.71c-0.91-4.29,2.86-29.48,2.16-31.94c-1.18-4.66-10.99-23.54-14.45-32.88 C222.18,191.91,214.8,199.86,214.8,199.86z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M207.08,260.91c0.06,0.09,0.13,0.17,0.21,0.25c0.96,0.92,3.16,1.06,4.49,0.19 c1.11-4.25,4.76-27.37,5.25-29.89c0.63-2.89,0.93-6.59,2.61-16.56c1.05-6.21,4.41-10,2.64-18.18c-1.17-7.77-7-4.1-9.52-3.74 c-1.96,0.28-3.47,0.65-3.47,0.65c0,2.46,0.18,10.65,0.04,13.97c-0.34,7.33,1.47,19.32,1.72,23.41 C207.96,238.51,206.08,253.91,207.08,260.91z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M207.08,260.91c0.06,0.09,0.13,0.17,0.21,0.25c0.21-0.93,0.34-1.89,0.51-2.83 c0.98-5.49,3.15-11.71,4.3-17.18c0.86-4.03,0.38-5.79,0.68-9.9c0.08-1.11,0.95-4.57,0.92-5.68c-0.06-3.32-1-6.55-1.3-9.84 c-0.17-1.84-0.12-3.69-0.09-5.54c0.03-1.7,0.07-3.4,0.11-5.1c0.06-3.19,0.13-6.39,0.2-9.6c0.01-0.85,0.07-1.68,0.15-2.51 c-1.96,0.28-3.47,0.65-3.47,0.65c0,2.46,0.18,10.65,0.04,13.97c-0.34,7.33,1.47,19.32,1.72,23.41 C207.96,238.51,206.08,253.91,207.08,260.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: -407.054,
    y1: 2199.5085,
    x2: -387.9379,
    y2: 2199.5085,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -697.712 -1855.3198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFEFEF"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M227.5,164.48c4.77,6.21,8.91,14.09,10.74,16.75c2.25-0.75,11.77-2.75,13.94-3 c1.04-0.17,1.67,3.21,0.87,3.66c-3.71,2.09-14.52,4.88-17.02,4.72c-2.67-2.33-9.31-11-10.7-15.92 C223.94,165.78,227.5,164.48,227.5,164.48z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -434.5415,
    y1: 2203.9634,
    x2: -402.2776,
    y2: 2203.9634,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -703.0969 -1866.3672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFEFEF"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M221.4,161.28l-6.36,0.8l-4.11,2.94c-0.54,0.59-2.02,2.21-2.31,4.18c0,0-0.36,13.8,0.62,24.93 c0.12,1.42,6.39,2.1,9.97,1.51c4.56-0.76,7.31-2.91,7.31-2.91c0.35-4.58,0.99-15.03,2.54-21.78c0.59-2.56,0.8-4.45-1.56-6.46 L221.4,161.28z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "221.16,161.38 223.11,163.3 221.68,166.66 218.28,163.17  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -421.0565,
    y1: 2188.5339,
    x2: -414.8484,
    y2: 2188.5339,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -694.5549 -1869.8091)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFEFEF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M221.16,161.29l-1.7,4.68c-0.77-0.15-2.1-0.73-2.92-1.16c-0.99-0.52-1.68-1.71-2.05-2.25 c0.53-0.7,0.81-1.22,1.34-1.92C215.82,160.63,218.55,161.66,221.16,161.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -414.8229,
    y1: 2188.4355,
    x2: -412.6248,
    y2: 2188.4355,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -693.5692 -1867.2539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFEFEF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M221.16,161.38l1.96,3.82l0.45-3.19l-1.1-1.17C222.47,160.84,221.4,161.11,221.16,161.38z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M221.83,165.33c1.09,2.6,1.12,6.08,1.97,9.7c1.04,4.4,1.29,8.69,1.39,11.94c-0.61,1.39-1.22,2.78-1.84,4.17 c-0.93-1.14-1.87-2.29-2.8-3.43c0.33-3.49,0.92-7.95,0.66-12.43c-0.19-3.32,0.22-6.63-0.26-9.35 C221.26,165.73,221.54,165.53,221.83,165.33z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M209.77,200.56c0.55,0.64,1.39,1.27,1.39,1.27c0.97,0.1,2.93,0.5,3.36,1.22c0.43,0.72,0.41,1.81,0.79,2.5 c-1.04,0.19-1.63-1.32-1.99-1.92c-1.04,0.05-1.7-0.71-1.86-0.59c0.73,0.61,1.72,3.01,3.48,3.74c1.75,0.74,3.08,1.8,2.9,2.31 c-2.55,0.42-3.72,1.46-5.19,0.38c-1.47-1.07-3.77-1.29-3.93-3.84c0.37-1.99,0.07-2.32-0.25-3.01c-0.31-0.68-1.28-1.92-1.28-1.92 L209.77,200.56z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M208.94,170.7c0,0-1.58,6.1,0.26,22.95c0,0.04,0.03,0.45,0.04,0.49c0.21,0.67,2.01,0.84,4.07,1.07 c-1.15-1.41-2.73-4.18-2.22-8.27c0.22-1.8,2.89-5.7,1.83-7.79C211.98,177.3,210.11,173.5,208.94,170.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -441.593,
    y1: 2211.0239,
    x2: -412.1909,
    y2: 2211.0239,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -708.1208 -1873.7529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C9C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFEFEF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M214.48,162.56c-3.84,1.43-7.3,1.48-8.3,2.73s-12.07,18.63-11.03,20.51c3.33,6.25,12.01,15.69,13.35,17.1 c1.12,0.97,3.25-1.5,2.84-2.32c-1.4-2.81-8.69-13.39-10.65-15.42c2.33-2.69,10.82-16.95,10.82-16.95L214.48,162.56z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M209.14,193.99c3.08,0.58,10.35,2.14,17.34-1.2c0.53,1.12,0.63,2.86,0.63,2.86 c-2.64,1.18-7.09,3.55-17.97,0.96C208.68,195.45,209.14,193.99,209.14,193.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -418.3049,
    y1: 2221.1226,
    x2: -412.0723,
    y2: 2221.1226,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -712.6641 -1861.8369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3CAD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M219,194.46c-0.19,0.81-0.31,3.19,0,3.62c0.81,0.12,3.85,0.08,4.8-1.12c0.13-1.2,0.46-2.86-0.24-3.06 C222.87,193.71,219,194.46,219,194.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.9661,
    y1: 2620.1797,
    x2: 140.983,
    y2: 2620.1797,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1192.1903 -1932.667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#735846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A4340"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M417.11,127.04c-0.1,3.09-2.78,5.63-2.9,8.72c-0.08,1.9,0.85,3.72,2.07,5.18c1.22,1.46,2.72,2.65,4.09,3.97 c0.42,0.41,0.85,0.86,1.02,1.43c0.16,0.57-0.03,1.29-0.58,1.52c1.4-0.53,2.66-0.82,3.92-1.63s2.37-1.91,2.93-3.3 c0.78-1.95,0.36-4.16-0.23-6.18c-0.72-2.49-1.71-4.98-3.45-6.91C422.24,127.92,419.68,126.65,417.11,127.04z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M390.4,150.73c-1.52-0.69-1.75-1.68-2.5-2.86c-0.75-1.17-4.02-2.35-5.63-1.86c-1.61,0.5-2.85,1.31-2.85,1.31 c1.57,1.01,3.84,0.21,5.04,1.18c1.19,0.98,2.54,1.99,3.01,2.32c-1.12-0.03-2.54-1.44-3.45-1.75c-0.91-0.3-1.72-0.78-2.08-0.07 c0.71,0.32,1.88,0.92,2.34,1.28s1.75,2.38,2.83,2.01c1.08-0.37,1.98-0.33,2.8,0.09C390.71,152.8,390.4,150.73,390.4,150.73z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M390.85,149.62c-0.44,0.34-0.81,0.78-1.11,1.3c-0.47,0.79-0.75,1.73-0.86,2.65 c-0.01,0.12,7.97,3.71,12.97,5.94c2.43,1.09,5.26,0.77,7.39-0.84l9.26-6.96l-0.86-2.52l-2.34-3.29l-7.71,7.79 c-1,0.95-2.45,1.23-3.73,0.73C400.58,153.14,394.3,150.71,390.85,149.62z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M430.68,143.91c-1.09-0.73-3.31-2.66-3.36-4.09c-1.84,0.23-5.11-1.36-5.32-0.09 c-0.41,2.47-3.27,3.72-3.27,3.72l-1.64,5.46l4.12,2.31l6.03-2.25L430.68,143.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.2197,
    y1: 1135.7662,
    x2: 430.446,
    y2: 1135.7662,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E098A9",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B398BA",
      stopOpacity: 0.68
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M426.86,238.44c-0.11,0.05-0.22,0.1-0.33,0.14c-2.72,1.16-7.37,2.2-9.67,4.51c-2.4,2.41,2.44,3.35,6.36,2.37 c3.69-0.92,5.09-1.72,6.24-2.17c1.27-0.5,1.18-2.35,0.48-4.54C429.24,236.56,426.86,238.44,426.86,238.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 121.4103,
    y1: 2642.8057,
    x2: 149.9729,
    y2: 2642.8057,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1204.2344 -1928.6343)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M429.21,142.72c-3.5,3.34-10.22,8.26-10.42,3.07c-1.39,2.93-5.98,9.8-4.76,13.82s2.45,14.73,2.45,14.73 s6.32,0.07,6.31-0.24c-0.01-0.31,3.32-21.02,3.32-21.02L429.21,142.72z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M429.27,239.09c-0.86,2.23-2.74,3.14-6.29,4.08c-4.07,1.08-5.68-0.98-1.73-2.65 c1.09-0.46,4.97-1.71,5.53-3.05s2.37-0.54,2.37-0.54L429.27,239.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.2182,
    y1: 1143.7999,
    x2: 429.06,
    y2: 1143.7999,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E098A9",
      stopOpacity: 0.68
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B398BA",
      stopOpacity: 0.68
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M424.36,245.47c-0.08,0.08-0.17,0.16-0.26,0.25c-2.19,1.99-6.23,4.51-7.64,7.45 c-1.47,3.07,4.13,3.03,6.89,0.41c2.75-2.63,3.86-3.3,5.32-4.59c0.92-0.81,0.1-2.39-1.29-4.23 C425.99,242.91,424.36,245.47,424.36,245.47z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M426.85,245.29c-0.08,2.39-2.45,3.58-4.59,5.93c-2.2,2.41-4.2,0.28-2.58-1.57c0.78-0.89,4.19-3.62,4.27-5.07 c0.08-1.45,2.06-1.3,2.06-1.3L426.85,245.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.8447,
    y1: 2689.5349,
    x2: 160.9855,
    y2: 2689.5349,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1231.641 -1920.061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A2D97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2875C6"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M431.35,174.29l-17.23-1.63c0,0-2.56,6.52-2.64,8.83c-0.49,15.36,14.37,58.42,14.37,58.42 s3.45-0.14,4.18-2.06c-0.15-0.02-9.08-40.41-7.76-55.54c0.24-2.77,5.98-0.16,5.98-0.16L431.35,174.29z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M431.35,174.29l-17.23-1.63c0,0-2.56,6.52-2.64,8.83c-0.49,15.36,14.37,58.42,14.37,58.42 s3.45-0.14,4.18-2.06c-0.15-0.02-9.08-40.41-7.76-55.54c0.24-2.77,5.98-0.16,5.98-0.16L431.35,174.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.9336,
    y1: 2692.5452,
    x2: 162.367,
    y2: 2692.5452,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1232.9628 -1918.3091)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A2D97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2875C6"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M431.74,176.22c4.07,9.49-9.21,23.94-10.22,36.09c5.58,13.62,6.48,21.18,6.54,32.12 c-0.2,1.83-4.77,1.8-4.73,0.38c-1.26-10.64-4.73-17.63-8.75-32.26c-0.45-14.65,4.07-27.57,4.96-39.9 C423.57,174.06,430.05,172.29,431.74,176.22z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M419.5,142.96c0,0-4.61,2.96-6.09,4.47c-1.9,3-0.2,12.48,0.6,16.31c0.23,1.08,0.11,2.21-0.34,3.22l-4.6,10.4 l1.88,4.36c3.2,5.18,7.05-3.66,6.78-10.68c-0.27-7.02-2.79-12.06-2.24-15.79c0.55-3.73,4.6-12.53,4.6-12.53L419.5,142.96z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M432.89,174.99c0.66,1.33,1.34,2.83,1.94,4.53c0,0-10.39,5.92-14.01,4.13c-1.5-0.74-1.83-2.54-1.77-4.83 c0-0.11,0-0.22,0.01-0.33c0.12-3.2,0.9-7.28,0.37-10.85c-0.94-6.29-1.32-8.21,0.08-12.12c1.39-3.92,9.39-13.07,9.39-13.07 l7.14,5.4c0,0-0.86,2.59-1.93,5.88c-1.65,5.04-3.8,11.73-4.16,13.35c-0.2,0.91,0.04,1.91,0.54,3.07c0.25,0.61,0.58,1.28,0.95,2 C431.88,173.01,432.38,173.95,432.89,174.99z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M429.17,142.19l2.57,2.19l-7.58,7.69l-1.29-0.3l0.54,2.88c0,0-2.9,2.69-4.64,8.36 c-0.71-5.29,0.44-8.24,4.44-13.51C426.98,144.53,429.17,142.19,429.17,142.19z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M432.89,174.99c-1.8,1.13-3.57,2.32-5.02,3.86c-0.5,0.54-0.96,1.11-1.57,1.51c-1.15,0.77-2.68,0.76-4,0.31 c-0.98-0.32-1.87-0.88-2.71-1.48c-0.13-0.1-0.4-0.23-0.54-0.37c-0.03-0.03-0.05-0.05-0.07-0.08c-0.11-0.18-0.07-0.19,0.08-0.25 c0.03-0.02,0.07-0.04,0.12-0.06c0.44-0.21,0.87-0.4,1.3-0.61c0.88-0.43,1.75-0.88,2.6-1.36c1.71-0.96,3.36-2.02,4.94-3.17 c0.47-0.34,0.93-0.69,1.45-0.94c0.52-0.25,1.11-0.38,1.67-0.28c0.1,0.02,0.2,0.05,0.3,0.08 C431.88,173.01,432.38,173.95,432.89,174.99z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M426.4,173.16c-0.73,0.27-1.67,0.39-1.67,0.39c-0.82-0.36-2.56-0.92-3.23-0.54s-1.14,1.26-1.75,1.63 c0.75,0.62,1.89-0.32,2.45-0.64c0.81,0.5,1.68,0.2,1.74,0.37c-0.85,0.16-2.72,1.62-4.45,1.42s-3.26,0.05-3.35,0.54 c1.85,1.48,2.32,2.83,3.96,2.64c1.65-0.2,3.58,0.66,4.86-1.29c0.6-1.75,0.99-1.88,1.55-2.29s1.88-0.95,1.88-0.95L426.4,173.16z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M415.93,144.62l4.41-2.43c0,0-4.93,9.76-4.65,14.03c0.28,4.28,0.25,4.79,0.86,6.81 c-1.37-2.09-2.67-6.97-2.38-10.05l1.82-1.44l-1.02-0.39L415.93,144.62z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M430.49,170.15c-0.39,0.55-0.92,1.01-1.52,1.31c-0.5,0.25-1.23,0.4-1.52-0.21c-0.2-0.39,0.06-0.61,0.08-0.99 c0.06-1.06-0.44-2.25-0.48-3.34c-0.08-2.33,0.43-4.68,1.52-6.73c1.33-2.53,3.44-4.53,5.54-6.46c-1.65,5.04-3.8,11.73-4.16,13.35 C429.75,167.99,429.99,168.99,430.49,170.15z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M436.05,147.85c2.53,1.82,5.78,14.69,6.37,19.44c0.08,0.9-11.1,8.04-15.09,9.12 c-2.24,0.58-2.99-2.65-1.74-3.45s7.3-5.83,10.94-7.83c-1.08-3.08-3.35-10.06-3.6-13.56S436.05,147.85,436.05,147.85z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M422.33,139.31c-2.6,1.17-4.35,1.03-4.54-0.09s-1.83-4.74-0.7-6.8c1.14-2.06,0-4.31,0-4.31 c0.82-2.06,2.42-2.5,2.42-2.5s6.84-0.88,8.15,4.56c1.31,5.44-0.62,9.96-0.62,9.96L422.33,139.31z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.6896,
    y1: 2623.3125,
    x2: 151.957,
    y2: 2623.3125,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1193.1636 -1930.0059)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#735846"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A4340"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M415.54,126.23c2.09-3.94,9.93-7.57,13.83-2.35c5,2.62,3.65,6.64,2.15,11.71s0.02,10.26,2.29,13.2 c2.27,2.94-5.86,9.62-6.95,10.5c-0.09-4.44,2.34-12.56,0-14.12s-3.9-7.19-1.03-10.5s1.21-4.21-3.88-6.56 C418,129.96,415.75,127.79,415.54,126.23z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionDevops);
export default __webpack_public_path__ + "static/media/solutionDevops.90893f3d1ec94fc37e4c7ab8dbd41ec9.svg";
export { ForwardRef as ReactComponent };